import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { IWorkerRecentProfit } from '@/entities/worker-stats.entity';
import { formatProfitUsd } from '@/lib/format-profit';
import { DollarSignIcon } from 'lucide-react';
import TimeAgo from 'react-timeago';
import russianStrings from 'react-timeago/lib/language-strings/ru';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

const formatter = buildFormatter(russianStrings);

interface RecentProfitsProps {
	profits: IWorkerRecentProfit[];
}

export default function RecentProfits({ profits }: RecentProfitsProps) {
	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-3'>
				<div className='flex items-center gap-2'>
					<div className='rounded-lg bg-chart-5/15 p-1.5'>
						<DollarSignIcon className='text-chart-5' size={16} />
					</div>
					<CardTitle className='text-sm'>Последние профиты</CardTitle>
				</div>
			</CardHeader>
			<CardContent className='px-4 py-2'>
				{profits.length === 0 ? (
					<div className='py-6 text-center text-sm text-muted-foreground'>Профитов пока нет</div>
				) : (
					<ul className='divide-y divide-border'>
						{profits.map(profit => (
							<li key={profit.id} className='flex items-center justify-between gap-3 py-3'>
								<span className='text-sm font-semibold tabular-nums text-chart-5'>+${formatProfitUsd(profit.amount)}</span>
								<span className='text-xs text-muted-foreground'>
									<TimeAgo date={profit.createdAt} formatter={formatter} />
								</span>
							</li>
						))}
					</ul>
				)}
			</CardContent>
		</Card>
	);
}
